const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const clean = (value, limit) => String(value || '').replace(/Bearer\s+[A-Za-z0-9._-]+/gi, 'Bearer [oculto]').slice(0, limit);

export function reportClientError(error, context = {}) {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return;
    const payload = {
      source: clean(context.source || 'browser', 80),
      name: clean(error?.name || 'Error', 120),
      message: clean(error?.message || error, 1800),
      stack: clean(error?.stack, 1800),
      component_stack: clean(context.componentStack, 1800),
      path: clean(`${window.location.pathname}${window.location.search}`, 500),
      app_version: clean(process.env.REACT_APP_VERSION || 'web', 80),
    };
    fetch(`${API_URL}/api/client-errors`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Telemetry must never interrupt the user flow.
  }
}
